import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { SessionService } from '../../shared/services/session.service'; 
declare var createjs:any;


@Component({
  selector: 'app-fk-st-writeownword',
  templateUrl: './fk-st-writeownword.component.html',
  styleUrls: ['./fk-st-writeownword.component.scss']
})


export class FKStWriteownwordComponent implements OnInit {
  private stage: any;
  public bloburl: string;
  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<FKStWriteownwordComponent>, @Inject(MAT_DIALOG_DATA) public data: string) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {
    var strbloburl = this.sessionService.bloburl;      
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)     
    var stage = new createjs.Stage("fk_bdcolorcanvas");
    this.stage = stage;
      createjs.Touch.enable(stage);
      createjs.MotionGuidePlugin.install();

    var fk_bdcolorcanvas: any = document.getElementById('fk_bdcolorcanvas');
    fk_bdcolorcanvas.width = 1785;
    fk_bdcolorcanvas.height = 885;

      var fk_bitmap = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/frame.png");
      fk_bitmap.setTransform(0, 0, 0.992, 0.97);

      var fk_heading = new createjs.Text("Bild och ord", "bold 60px Dk-mariken", "#FF0000");
      if (isIOS) {        
        var fk_heading = new createjs.Text("Bild och ord", "60px Dk-mariken", "#FF0000");
        fk_heading.outline = 2;
        var fk_heading1 = new createjs.Text("Bild och ord", "60px Dk-mariken", "#FF0000");
        fk_heading1.textAlign = "center";
        fk_heading1.setTransform(892, 80);
      }
      fk_heading.textAlign = "center";
      fk_heading.setTransform(892, 80);


      //Random Image
      var fk_ImgArr = [strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/sko.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/fyr.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/hus.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/orm.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/nos.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/oga.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/vag.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/wok.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/yxa.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/orn.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/apa.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/arm.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/bil.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/bok.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/bat.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/eld.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/ett.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/fem.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/fot.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/gul.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/haj.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/kam.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/las.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/lok.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/mus.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/nio.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/nal.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/ost.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/pil.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/rav.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/rod.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/sax.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/sol.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/sag.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/tak.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/tre.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/tag.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/val.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/zoo.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/ara.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/agg.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/alg.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/ora.png",
        strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/sex.png"];

      var fk_ImgArr_X = [87, 148, 87, 105, 125, 115, 87, 103, 117, 127, 109, 64, 87, 98, 90, 97, 137, 110, 97, 77, 67, 87, 117, 101, 92, 104, 87, 70, 87, 81, 77, 120, 100, 74, 84, 127, 82, 102, 82, 87, 117, 78, 117, 107];

      var fk_ImgArr_Y = [80, 28, 80, 91, 108, 95, 110, 60, 60, 60, 40, 70, 90, 85, 50, 40, 70, 60, 80, 55,
        85, 50, 40, 50, 50, 55, 50, 57, 90, 70, 60, 55, 60, 67, 80, 60, 75, 70, 70, 70, 60, 60, 40, 45];

      var fk_showimage = [];
      for (var k = 0; k < fk_ImgArr.length; k++) {
        var fk_ImgArray = { Img: fk_ImgArr[k], Img_X: fk_ImgArr_X[k], Img_Y: fk_ImgArr_Y[k] };
        fk_showimage.push(fk_ImgArray);
      }

      //Random Question Text
      var fk_QstnTxt1 = ["s", "f", "h", "o", "n", "ö", "v", "w", "y", "ö", "a", "a", "b", "b", "b", "e", "e", "f", "f", "g", "h", "k", "l", "l", "m", "n", "n", "o", "p", "r", "r", "s", "s", "s", "t", "t", "t", "v", "z", "å", "ä", "ä", "ö", "s"];
      

      var fk_QstnTxt1_X = [749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749, 749];
      var fk_QstnTxt1_Y = [690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690, 690];

      var fk_QstnTxt2 = ["k", "y", "u", "r", "o", "g", "å", "o", "x", "r", "p", "r", "i", "o", "å", "l", "t", "e", "o", "u", "a", "a", "å", "ö", "u", "i", "å", "s", "i", "ä", "ö", "a", "o", "å", "a", "r", "å","a", "o", "r", "g", "l", "r", "e"];
      var fk_QstnTxt2_X = [838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838, 838];
      var fk_QstnTxt2_Y = [692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692];


      var fk_QstnTxt3 = ["o", "r", "s", "m", "s", "a", "g", "k", "a", "n", "a", "m", "l", "k", "t", "d", "t", "m", "t", "l", "j", "m", "s", "k", "s", "o", "l", "t", "l", "v", "d", "x", "l", "g", "k", "e", "g", "l", "o", "a", "g", "g", "a", "x"];


      var fk_QstnTxt3_X = [929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929, 929];
      var fk_QstnTxt3_Y = [692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692, 692];

      var fk_showQuestion = [];
      for (var k = 0; k < fk_ImgArr.length; k++) {
        var QstnArray = {
          Qstn1: fk_QstnTxt1[k], Qstn1_X: fk_QstnTxt1_X[k], Qstn1_Y: fk_QstnTxt1_Y[k],
          Qstn2: fk_QstnTxt2[k], Qstn2_X: fk_QstnTxt2_X[k], Qstn2_Y: fk_QstnTxt2_Y[k],
          Qstn3: fk_QstnTxt3[k], Qstn3_X: fk_QstnTxt3_X[k], Qstn3_Y: fk_QstnTxt3_Y[k]
        };
        fk_showQuestion.push(QstnArray);
      }


      //Answer fk_destination

      var fk_AnsTxt1 = ["s", "f", "h", "o", "n", "ö", "v", "w", "y", "ö", "a", "a", "b", "b", "b", "e", "e", "f", "f", "g", "h", "k", "l", "l", "m", "n", "n", "o", "p", "r", "r", "s", "s", "s", "t", "t", "t", "v", "z", "å", "ä", "ä", "ö", "s"];
      var fk_AnsTxt1_X = [748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5,748.5];
      var fk_AnsTxt1_Y = [519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519, 519];

      var fk_AnsTxt2 = ["k", "y", "u", "r", "o", "g", "å", "o", "x", "r", "p", "r", "i", "o", "å", "l", "t", "e", "o", "u", "a", "a", "å", "ö", "u", "i", "å", "s", "i", "ä", "ö", "a", "o", "å", "a", "r", "å", "a", "o", "r", "g", "l", "r", "e"];
      var fk_AnsTxt2_X = [839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 842, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839, 839];
      var fk_AnsTxt2_Y = [521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521];

      var fk_AnsTxt3 = ["o", "r", "s", "m", "s", "a", "g", "k", "a", "n", "a", "m", "l", "k", "t", "d", "t", "m", "t", "l", "j", "m", "s", "k", "s", "o", "l", "t", "l", "v", "d", "x", "l", "g", "k", "e", "g","l", "o", "a", "g", "g", "a", "x"];
      var fk_AnsTxt3_X = [928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5,928.5];
      var fk_AnsTxt3_Y = [522, 521, 521, 521, 521, 521, 521, 521, 521, 521, 519, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521, 521];

      var showAnswer = [];
      for (var k = 0; k < fk_ImgArr.length; k++) {
        var fk_AnsArray = {
          Ans1: fk_AnsTxt1[k], Ans1_X: fk_AnsTxt1_X[k], Ans1_Y: fk_AnsTxt1_Y[k],
          Ans2: fk_AnsTxt2[k], Ans2_X: fk_AnsTxt2_X[k], Ans2_Y: fk_AnsTxt2_Y[k],
          Ans3: fk_AnsTxt3[k], Ans3_X: fk_AnsTxt3_X[k], Ans3_Y: fk_AnsTxt3_Y[k]
        };
        showAnswer.push(fk_AnsArray);
      }


      Demo();

      function Demo() {


        //Image container
        var fk_container1 = new createjs.Container();
        var fk_img_rect = new createjs.Shape();
        fk_img_rect.graphics.setStrokeStyle(2).f('').beginStroke("#A6CD7F").drawRoundRect(0, 0, 250, 250, 10);
        fk_img_rect.setTransform(60, 20);
        fk_container1.addChild(fk_img_rect);
        fk_container1.name = "removeimage";
                
             

        var fk_randomnum = Math.floor((Math.random() * fk_showimage.length));
        var bitmap1 = new createjs.Bitmap(fk_showimage[fk_randomnum].Img);
        bitmap1.x = fk_showimage[fk_randomnum].Img_X;
        bitmap1.y = fk_showimage[fk_randomnum].Img_Y;
        fk_container1.addChild(bitmap1);
        fk_container1.setTransform(708, 170);

        //dropping container 
        var fk_container2 = new createjs.Container();

        //declare fk_dragger status is null before complete the drag and drop of 3 objects
        var fk_dstatus1 = null;
        var fk_dstatus2 = null;
        var fk_dstatus3 = null;

       

        var fk_img_rect3 = new createjs.Shape();
        fk_img_rect3.graphics.setStrokeStyle(2).f('').beginStroke("#A6CD7F").drawRoundRect(0, 0, 270, 90, 0).moveTo(90,0).lineTo(90,90).moveTo(180,0).lineTo(180,90);
        fk_img_rect3.setTransform(760, 509);
        fk_container2.addChild(fk_img_rect3);

       

        var fk_newexe = new Image();
        fk_newexe.crossOrigin = "Anonymous";
        fk_newexe.src = strbloburl + "/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/newexercise.png";

        


        var bitmap6 = new createjs.Bitmap(fk_newexe);
        bitmap6.setTransform(1550, 745);
        bitmap6.visible = false;
        bitmap6.cursor = 'pointer';

        


        bitmap6.addEventListener("click", function (event: any) {
          bitmap6.visible = false;
          bitmap6.cursor = 'pointer';
          for (var j = 0; j < stage.children.length; j++) {
            if (stage.children[j].name == "removeimage") {
              stage.removeChild(stage.children[j]);
              j = j - 1;
            }
          }
          Demo();
        })

        //shuffeling function

        function shuffle(fk_array) {
          var fk_currentIndex = fk_array.length, temporaryValue, randomIndex;

          // While there remain elements to shuffle...
          while (0 !== fk_currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * fk_currentIndex);
            fk_currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = fk_array[fk_currentIndex];
            fk_array[fk_currentIndex] = fk_array[randomIndex];
            fk_array[randomIndex] = temporaryValue;
          }

          return fk_array;
        }

        var fk_QstnTxtArr = [];
        fk_QstnTxtArr = [fk_showQuestion[fk_randomnum].Qstn1, fk_showQuestion[fk_randomnum].Qstn2, fk_showQuestion[fk_randomnum].Qstn3];
        

        // Used like so
        var fk_arr = [fk_showQuestion[fk_randomnum].Qstn1_X, fk_showQuestion[fk_randomnum].Qstn2_X, fk_showQuestion[fk_randomnum].Qstn3_X];
        fk_arr = shuffle(fk_arr);
        if (fk_arr[0] < fk_arr[1] && fk_arr[1] < fk_arr[2]) {
          fk_arr = shuffle(fk_arr);
        }    

        //Audio 
        var fk_sounds: any[string];
        fk_sounds = new Array(13);
        for (var i = 0; i < 13; i++) {
          fk_sounds[i] = new Audio();
          fk_sounds[i].src = strbloburl + '/Lasresan/FK/FK-StudentsWeb/Tincan/writeownword/audio/audio' + i + '.mp3';
        }

        var fk_randomaudio = Math.floor((Math.random() * fk_sounds.length));

        //fk_label ofk_ption 1

        var fk_destHeight = 70;
        var fk_destWidth = 40;

        var fk_RectWidth1 = 50;
        var fk_RectHeight1 = 38;

        var fk_RectWidth2 = 50;
        var fk_RectHeight2 = 38;

        var fk_RectWidth3 = 50;
        var fk_RectHeight3 = 38;

        //fk_label ofk_ption k
        var fk_rect1 = new createjs.Shape();
        fk_rect1.graphics.setStrokeStyle(2).f("#FFFFFF").drawRect(31, 15, fk_RectWidth1, fk_RectHeight1);
        fk_rect1.alpha = 0.1;

        var fk_label1 = new createjs.Text(fk_showQuestion[fk_randomnum].Qstn1, "100px MajemaSkol_Exercise_bold", "#696969");
        fk_label1.textAlign = "center";        
        fk_label1.textBaseline = (isChrome == true) ? 'middle' : 'top';
        fk_label1.x = 56;
        fk_label1.y = (isChrome == true) ? 18 : (isFirefox == true) ? -26 : -17;
                



        var fk_dragger1 = new createjs.Container();
        fk_dragger1.cursor = 'pointer';
        fk_dragger1.x = fk_arr[0];
        fk_dragger1.y = fk_showQuestion[fk_randomnum].Qstn1_Y;
        stage.enableMouseOver(20);
        fk_dragger1.addChild(fk_rect1, fk_label1);
        fk_dragger1.name = "removeimage";
        fk_dragger1.setBounds(202, 107, 50, 50);

        //fk_label s
        var fk_rect2 = new createjs.Shape();
        fk_rect2.graphics.setStrokeStyle(2).f("#FFFFFF").drawRect(31, 15, fk_RectWidth1, fk_RectHeight1);
        fk_rect2.alpha = 0.1;


        var fk_label2 = new createjs.Text(fk_showQuestion[fk_randomnum].Qstn2, "100px MajemaSkol_Exercise_bold", "#696969");
        fk_label2.textAlign = "center";
        
        fk_label2.textBaseline = (isChrome == true) ? 'middle' : 'top';
        fk_label2.x = 56;
        fk_label2.y = (isChrome == true) ? 18 : (isFirefox == true) ? -26 : -17;
                


        var fk_dragger2 = new createjs.Container();
        fk_dragger2.cursor = 'pointer';
        fk_dragger2.x = fk_arr[1];
        fk_dragger2.y = fk_showQuestion[fk_randomnum].Qstn2_Y;
        stage.enableMouseOver(20);
        fk_dragger2.addChild(fk_rect2, fk_label2);
        fk_dragger2.name = "removeimage";
        fk_dragger2.setBounds(202, 107, 50, 50);

        //fk_label o

        var fk_rect3 = new createjs.Shape();
        fk_rect3.graphics.setStrokeStyle(2).f("#FFFFFF").drawRect(31, 15, fk_RectWidth1, fk_RectHeight1);
        fk_rect3.alpha = 0.1;

        var fk_label3 = new createjs.Text(fk_showQuestion[fk_randomnum].Qstn3, "100px MajemaSkol_Exercise_bold", "#696969");
        fk_label3.textAlign = "center";       
        fk_label3.textBaseline = (isChrome == true) ? 'middle' : 'top';
        fk_label3.x = 56;
        fk_label3.y = (isChrome == true) ? 18 : (isFirefox == true) ? -26 : -17;
               

        var fk_dragger3 = new createjs.Container();
        fk_dragger3.cursor = 'pointer';
        fk_dragger3.x = fk_arr[2];
        fk_dragger3.y = fk_showQuestion[fk_randomnum].Qstn3_Y;
        stage.enableMouseOver(20);
        fk_dragger3.addChild(fk_rect3, fk_label3);
        fk_dragger3.name = "removeimage";
        fk_dragger3.setBounds(202, 107, 50, 50);


        //fk_destination for all dragged objects
        var valuey;
        var count = 0;

        //s
        var fk_destination1 = new createjs.Container();
        fk_destination1.setBounds(720, 490, 35, 65);

        //k
        var fk_destination2 = new createjs.Container();
        fk_destination2.setBounds(820, 490, 35, 65);

        //o
        var fk_destination3 = new createjs.Container();
        fk_destination3.setBounds(896, 490, 35, 65);

        //fk_dragger k
        fk_dragger1.on("pressmove", function (evt: any) {
          if (count == 0) {
            valuey = evt.currentTarget.y;
            count = 1;
          }
          evt.currentTarget.x = evt.stageX - (fk_RectWidth1);
          evt.currentTarget.y = evt.stageY - (fk_RectHeight1);
          

          if (intersect(evt.currentTarget, fk_destination1)) {

          }

        });


        fk_dragger1.on("pressup", function (evt: any) {
          if ((fk_QstnTxtArr[0] == fk_QstnTxtArr[1]) || (fk_QstnTxtArr[0] == fk_QstnTxtArr[2])) {
            if (fk_QstnTxtArr[0] == fk_QstnTxtArr[1]) {
              if ((intersect(evt.currentTarget, fk_destination1)) && fk_dstatus1 != "active") {
                fk_dragger1.x = showAnswer[fk_randomnum].Ans1_X;
                fk_dragger1.y = showAnswer[fk_randomnum].Ans1_Y;
                fk_dstatus1 = "active";
                fk_dragger1.mouseEnabled = false;
                checking();
                
              } else if ((intersect(evt.currentTarget, fk_destination2)) && fk_dstatus2 != "active") {
                fk_dragger1.x = showAnswer[fk_randomnum].Ans2_X;
                fk_dragger1.y = showAnswer[fk_randomnum].Ans2_Y;
                fk_dstatus2 = "active";
                fk_dragger1.mouseEnabled = false;
                checking();
                
              } else {
                createjs.Tween.get(fk_dragger1)
                  .to({ x: fk_arr[0], y: fk_showQuestion[fk_randomnum].Qstn1_Y }, 500);
                
              }
            } else if (fk_QstnTxtArr[0] == fk_QstnTxtArr[2]) {
              if ((intersect(evt.currentTarget, fk_destination1)) && fk_dstatus1 != "active") {
                fk_dragger1.x = showAnswer[fk_randomnum].Ans1_X;
                fk_dragger1.y = showAnswer[fk_randomnum].Ans1_Y;
                fk_dstatus1 = "active";
                fk_dragger1.mouseEnabled = false;
                checking();
                
              } else if ((intersect(evt.currentTarget, fk_destination3)) && fk_dstatus3 != "active") {
                fk_dragger1.x = showAnswer[fk_randomnum].Ans3_X;
                fk_dragger1.y = showAnswer[fk_randomnum].Ans3_Y;
                fk_dstatus3 = "active";
                fk_dragger1.mouseEnabled = false;
                checking();
                
              } else {
                createjs.Tween.get(fk_dragger1)
                  .to({ x: fk_arr[0], y: fk_showQuestion[fk_randomnum].Qstn1_Y }, 500);
                
              }
            }

          } else {
            if (intersect(evt.currentTarget, fk_destination1)) {
              fk_dragger1.x = showAnswer[fk_randomnum].Ans1_X;
              fk_dragger1.y = showAnswer[fk_randomnum].Ans1_Y;
              fk_dstatus1 = "active";
              fk_dragger1.mouseEnabled = false;
              checking();
              
            } else {
              createjs.Tween.get(fk_dragger1)
                .to({ x: fk_arr[0], y: fk_showQuestion[fk_randomnum].Qstn1_Y }, 500);
              
            }
          }
        });



        //fk_dragger o

        fk_dragger2.on("pressmove", function (evt: any) {
          if (count == 0) {
            valuey = evt.currentTarget.y;
            count = 1;
          }
          evt.currentTarget.x = evt.stageX - (fk_RectWidth2);
          evt.currentTarget.y = evt.stageY - (fk_RectHeight2);
          

          if (intersect(evt.currentTarget, fk_destination2)) {

          }

        });


        fk_dragger2.on("pressup", function (evt: any) {
          if ((fk_QstnTxtArr[1] == fk_QstnTxtArr[0]) || (fk_QstnTxtArr[1] == fk_QstnTxtArr[2])) {
            if (fk_QstnTxtArr[1] == fk_QstnTxtArr[0]) {
              if ((intersect(evt.currentTarget, fk_destination1)) && fk_dstatus1 != "active") {
                fk_dragger2.x = showAnswer[fk_randomnum].Ans1_X;
                fk_dragger2.y = showAnswer[fk_randomnum].Ans1_Y;
                fk_dstatus1 = "active";
                fk_dragger2.mouseEnabled = false;
                checking();
                
              } else if ((intersect(evt.currentTarget, fk_destination2)) && fk_dstatus2 != "active") {
                fk_dragger2.x = showAnswer[fk_randomnum].Ans2_X;
                fk_dragger2.y = showAnswer[fk_randomnum].Ans2_Y;
                fk_dstatus2 = "active";
                fk_dragger2.mouseEnabled = false;
                checking();
               
              } else {
                createjs.Tween.get(fk_dragger2)
                  .to({ x: fk_arr[1], y: fk_showQuestion[fk_randomnum].Qstn2_Y }, 500);
                
              }
            } else if (fk_QstnTxtArr[1] == fk_QstnTxtArr[2]) {
              if ((intersect(evt.currentTarget, fk_destination2)) && fk_dstatus2 != "active") {
                fk_dragger2.x = showAnswer[fk_randomnum].Ans2_X;
                fk_dragger2.y = showAnswer[fk_randomnum].Ans2_Y;
                fk_dstatus2 = "active";
                fk_dragger2.mouseEnabled = false;
                checking();
                
              } else if ((intersect(evt.currentTarget, fk_destination3)) && fk_dstatus3 != "active") {
                fk_dragger2.x = showAnswer[fk_randomnum].Ans3_X;
                fk_dragger2.y = showAnswer[fk_randomnum].Ans3_Y;
                fk_dstatus3 = "active";
                fk_dragger2.mouseEnabled = false;
                checking();
                
              } else {
                createjs.Tween.get(fk_dragger2)
                  .to({ x: fk_arr[1], y: fk_showQuestion[fk_randomnum].Qstn2_Y }, 500);
                
              }
            }
          } else {
            if (intersect(evt.currentTarget, fk_destination2)) {
              fk_dragger2.x = showAnswer[fk_randomnum].Ans2_X;
              fk_dragger2.y = showAnswer[fk_randomnum].Ans2_Y;
              fk_dstatus2 = "active";
              fk_dragger2.mouseEnabled = false;
              checking();
              
            }
            else {
              createjs.Tween.get(fk_dragger2)
                .to({ x: fk_arr[1], y: fk_showQuestion[fk_randomnum].Qstn2_Y }, 500);
              
            }
          }

        });


        //fk_dragger s
        fk_dragger3.on("pressmove", function (evt: any) {
          if (count == 0) {
            valuey = evt.currentTarget.y;
            count = 1;
          }
          evt.currentTarget.x = evt.stageX - (fk_RectWidth2);
          evt.currentTarget.y = evt.stageY - (fk_RectHeight2);
          

          if (intersect(evt.currentTarget, fk_destination2)) {

          }

        });

        fk_dragger3.on("pressup", function (evt: any) {
          if ((fk_QstnTxtArr[2] == fk_QstnTxtArr[0]) || (fk_QstnTxtArr[2] == fk_QstnTxtArr[1])) {
            if (fk_QstnTxtArr[2] == fk_QstnTxtArr[0]) {
              if ((intersect(evt.currentTarget, fk_destination1)) && fk_dstatus1 != "active") {
                fk_dragger3.x = showAnswer[fk_randomnum].Ans1_X;
                fk_dragger3.y = showAnswer[fk_randomnum].Ans1_Y;
                fk_dstatus1 = "active";
                fk_dragger3.mouseEnabled = false;
                checking();
                
              } else if ((intersect(evt.currentTarget, fk_destination3)) && fk_dstatus3 != "active") {
                fk_dragger3.x = showAnswer[fk_randomnum].Ans3_X;
                fk_dragger3.y = showAnswer[fk_randomnum].Ans3_Y;
                fk_dstatus3 = "active";
                fk_dragger3.mouseEnabled = false;
                checking();
                
              } else {
                createjs.Tween.get(fk_dragger3)
                  .to({ x: fk_arr[2], y: fk_showQuestion[fk_randomnum].Qstn3_Y }, 500);
               
              }
            } else if (fk_QstnTxtArr[2] == fk_QstnTxtArr[1]) {
              if ((intersect(evt.currentTarget, fk_destination2)) && fk_dstatus2 != "active") {
                fk_dragger3.x = showAnswer[fk_randomnum].Ans2_X;
                fk_dragger3.y = showAnswer[fk_randomnum].Ans2_Y;
                fk_dstatus2 = "active";
                fk_dragger3.mouseEnabled = false;
                checking();
                
              } else if ((intersect(evt.currentTarget, fk_destination3)) && fk_dstatus3 != "active") {
                fk_dragger3.x = showAnswer[fk_randomnum].Ans3_X;
                fk_dragger3.y = showAnswer[fk_randomnum].Ans3_Y;
                fk_dstatus3 = "active";
                fk_dragger3.mouseEnabled = false;
                checking();
                
              } else {
                createjs.Tween.get(fk_dragger3)
                  .to({ x: fk_arr[2], y: fk_showQuestion[fk_randomnum].Qstn3_Y }, 500);
                
              }
            }
          } else {
            if (intersect(evt.currentTarget, fk_destination3)) {
              fk_dragger3.x = showAnswer[fk_randomnum].Ans3_X;
              fk_dragger3.y = showAnswer[fk_randomnum].Ans3_Y;
              fk_dragger3.mouseEnabled = false;
              fk_dstatus3 = "active";
              checking();
              
            }
            else {
              createjs.Tween.get(fk_dragger3)
                .to({ x: fk_arr[2], y: fk_showQuestion[fk_randomnum].Qstn3_Y }, 500);
              
            }
          }

        });

        function checking() {
          if (fk_dstatus1 == "active" && fk_dstatus2 == "active" && fk_dstatus3 == "active") {
            fk_dstatus1 = null;
            fk_dstatus2 = null;
            fk_dstatus3 = null;
            fk_sounds[fk_randomaudio].play();
            fk_showimage.splice(fk_randomnum, 1);
            fk_showQuestion.splice(fk_randomnum, 1);
            showAnswer.splice(fk_randomnum, 1);
            if (fk_showimage.length > 0) {
              bitmap6.visible = true;
              bitmap6.alpha = 1;
            } else {
              bitmap6.visible = true;
              bitmap6.cursor = 'default';
              bitmap6.alpha = 0.3;
              bitmap6.removeAllEventListeners();
            }

          }

        }


        function intersect(obj1, obj2) {
          var fk_objBounds1 = obj1.getBounds().clone();
          var fk_objBounds2 = obj2.getBounds().clone();

          var fk_pt = obj1.globalToLocal(fk_objBounds2.x, fk_objBounds2.y);

          var fk_h1 = -(fk_objBounds1.height / 2 + fk_objBounds2.height);
          var fk_h2 = fk_objBounds2.width / 2;
          var fk_w1 = -(fk_objBounds1.width / 2 + fk_objBounds2.width);
          var fk_w2 = fk_objBounds2.width / 2;


          if (fk_pt.x > fk_w2 || fk_pt.x < fk_w1) return false;
          if (fk_pt.y > fk_h2 || fk_pt.y < fk_h1) return false;

          return true;
        }


        stage.addChild(fk_container1, fk_container2, bitmap6, fk_dragger1, fk_dragger2, fk_dragger3, fk_destination2, fk_destination3);
        stage.addChild(fk_bitmap, fk_heading, fk_heading1);
      }
    stage.mouseMoveOutside = false;
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }


  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');
    let toggler: any = document.getElementById("toggler");
    if (toggler) {
      toggler.style.visibility = "visible";
    }
  }
}
